"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _button = _interopRequireDefault(require("@clayui/button"));
var _form = require("@clayui/form");
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _shared = require("@clayui/shared");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _DropDownContext = require("./DropDownContext");
var _excluded = ["className", "defaultValue", "formProps", "onChange", "spritemap", "submitProps", "value"],
  _excluded2 = ["className", "onSubmit"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var defaultOnSubmit = function defaultOnSubmit(event) {
  return event.preventDefault();
};
var defaultSubmitProps = {
  'aria-label': 'Search',
  type: 'button'
};
var Search = function Search(_ref) {
  var className = _ref.className,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
    _ref$formProps = _ref.formProps,
    formProps = _ref$formProps === void 0 ? {} : _ref$formProps,
    onChange = _ref.onChange,
    spritemap = _ref.spritemap,
    _ref$submitProps = _ref.submitProps,
    submitProps = _ref$submitProps === void 0 ? defaultSubmitProps : _ref$submitProps,
    valueProp = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var formClassName = formProps.className,
    onSubmit = formProps.onSubmit,
    otherFormProps = _objectWithoutProperties(formProps, _excluded2);
  var _useControlledState = (0, _shared.useControlledState)({
      defaultName: 'defaultValue',
      defaultValue: defaultValue,
      handleName: 'onChange',
      name: 'value',
      onChange: onChange,
      value: valueProp
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 3),
    value = _useControlledState2[0],
    setValue = _useControlledState2[1],
    isUncontrolled = _useControlledState2[2];
  var _useContext = (0, _react.useContext)(_DropDownContext.DropDownContext),
    onSearch = _useContext.onSearch,
    tabFocus = _useContext.tabFocus;
  (0, _react.useEffect)(function () {
    if (isUncontrolled) {
      onSearch(value);
    }
  }, [isUncontrolled, value]);
  return /*#__PURE__*/_react.default.createElement("form", _extends({
    className: (0, _classnames.default)(className, formClassName),
    onSubmit: onSubmit ? onSubmit : defaultOnSubmit
  }, otherFormProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-section"
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.Group, {
    small: true
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    className: "input-group-item-focusable"
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput, _extends({}, otherProps, {
    insetAfter: true,
    onChange: function onChange(event) {
      return setValue(event.target.value);
    },
    tabIndex: !tabFocus ? -1 : undefined,
    type: "text",
    value: value
  })), /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupInsetItem, {
    after: true,
    tag: "span"
  }, /*#__PURE__*/_react.default.createElement(_button.default, _extends({}, submitProps, {
    displayType: "unstyled",
    tabIndex: !tabFocus ? -1 : undefined
  }), /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "search"
  })))))));
};
var _default = exports.default = Search;